import React, { useEffect, useRef, useState } from "react";
import Cookies from 'js-cookie';
import Modal from 'react-modal';
import MediaGalleryWidget from "../features/home/ui/MediaGalleryWidget";
import { fetchCounterPoints } from "../features/home/api/homeApi";
import { getLanguageSection } from "../shared/services/languageService";

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

function Home() {
  const [pointsAvailable, setPointsAvailable] = useState(0);
  const [pointsPending, setPointsPending] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const subtitleRef = useRef(null);

  const language = getLanguageSection('home');
  const countryUser = Cookies.get('CountryUser');

  useEffect(() => {
    fetchCounterPoints({
      userAccessToken: Cookies.get('UserAccessToken'),
      deviceAccessToken: Cookies.get('DeviceAccessToken')
    })
      .then(({ pointsAvailable: available, pointsPending: pending }) => {
        setPointsAvailable(available);
        setPointsPending(pending);
      })
      .catch(() => {});

    const today = new Date();
    const fullYearModal = today.getFullYear();
    const getMouthModal = today.getMonth() + 1;
    const getDayModal = today.getDate();

    const todayModal = fullYearModal + "-" + getMouthModal + "-" + getDayModal;
    const a = new Date(todayModal);
    const endDateModal = new Date('2020-02-29');
    const endDateModal1 = new Date('2020-2-29');

    if (a < endDateModal || a < endDateModal1) {
      setModalIsOpen(Cookies.get('modalnews') === 'open');
    } else {
      setModalIsOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const afterOpenModal = () => {
    if (subtitleRef.current) {
      subtitleRef.current.style.color = '#f00';
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
    Cookies.set('modalnews', false);
  };

  let news = [];

  if (countryUser === '40') {
    news = [
      <div dangerouslySetInnerHTML={{ __html: language.newsAll }} />
    ];
  }
  if (countryUser === '167') {
    news = [
      language.news35,
    ];
  }
  if (countryUser === '254') {
    news = [
      <div dangerouslySetInnerHTML={{ __html: language.newsAll }} />
    ];
  }

  return (

       <div id="home" className="mr-ui bg-[#f3f5fb] pb-10">
        <div className="mx-auto w-full max-w-7xl px-5 md:px-8">
          {/* Bloque de puntos: solo para agentes de México (CountryUser === '167') */}
          {countryUser === '167' ? (
            <div className="grid gap-5 md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(280px,1.45fr)]">
              <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
                <h3 className="m-0 text-xl font-normal text-marival-navy">{language.text1}</h3>
              </div>

              <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
                <div className="flex flex-col gap-3">
                  <div className="flex items-center gap-4">
                    <span className="min-w-10 text-3xl font-normal leading-none text-marival-sky">{pointsPending}</span>
                    <span className="text-sm font-normal uppercase text-slate-500">{language.pending}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <span className="min-w-10 text-3xl font-normal leading-none text-marival-sky">{pointsAvailable}</span>
                    <span className="text-sm font-normal uppercase text-slate-500">{language.available}</span>
                  </div>
                </div>
              </div>

              <div className="rounded-xl bg-marival-coral p-7 text-white shadow-coral">
                <p className="m-0 text-base font-normal leading-7">{language.text2}</p>
                <h3 className="m-0 mt-1 text-2xl font-semibold leading-tight">{language.text3}</h3>
              </div>
            </div>
          ) : null}

          <section className="mt-6 rounded-xl border border-slate-200 bg-white p-6 shadow-sm md:p-8">
            <div className="mb-6 flex flex-wrap items-center justify-between gap-4 border-b border-slate-100 pb-5">
              <h2 className="m-0 text-2xl font-normal text-marival-navy">{language.latestnews}</h2>
              <span className="rounded-full bg-[#eaf6fb] px-4 py-2 text-xs font-semibold uppercase tracking-wide text-marival-sky">
                {language.media}
              </span>
            </div>

            {
              news.map(function(item, i){
                return(
                <div className="mb-4 flex items-start gap-4 rounded-xl border border-slate-100 bg-slate-50/60 p-5" key={i}>
                  <span className="mt-1 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-orange-100 text-[#f5660b]">
                    <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="m5 12 4 4L19 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                  <div className="text-sm leading-7 text-slate-600">{item}</div>
                </div>)
              })
            }

            <div className="mt-6 border-t border-slate-100 pt-6">
              <MediaGalleryWidget />
            </div>
          </section>
        </div>

  {/* ******************************************************* */}
  {countryUser === '167' || countryUser === '254' ?
  <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >

        <h2 ref={subtitleRef}>{language.modaltitle}</h2>

        <div>
          <p>{language.modaltext}</p>
          <p>{language.modaltext1}</p>
        </div>

      </Modal>:null}

  </div>
  );
}

export default Home;
